// import Logger from './Logger';
import { Inviter, Registerer, SessionState, UserAgent, Web } from 'sip.js';
import { makePeerConsumerSelector } from './store/selectors';
import { store } from './store/store';

// const logger = new Logger('SIP');

export default class SIPCalling
{
	constructor(registrationURI, callerURI, roomClient)
	{
		this._registrationURI = `sip:${registrationURI}`;

		this._callerURI = callerURI;

		this._roomClient = roomClient;

		this._captureStream = null;

		this._selfVideo = null;

		this._sampleVideo = null;

		this._audioContextRef = new AudioContext();
		this._destinationRef = this._audioContextRef.createMediaStreamDestination();
		// this._gainNodeRef = this._audioContextRef.createGain();
		if (this._audioContextRef.state === 'suspended')
		{

			this._audioContextRef?.resume();
		}

		// this._gainNodeRef.gain.value = 1;
		// this._gainNodeRef.connect(this._destinationRef);

		this._audioConsumersMap = new Map();

		this._invitation = null;

		this._userAgent = null;

		this._customStream = null;

		this._registerID = null;

		this._sipMediaStream = new MediaStream();

		this._sipAudioMicCtx = new AudioContext();
		this._sipDestination = this._sipAudioMicCtx.createMediaStreamDestination();
		this._SipGainNode = this._sipAudioMicCtx.createGain();

		this._customVideoTrack = null;

		this._customAudioTrack = null;

		this._sampleAudioTrackId = null;

		this._called = false;

		this._meetingInfo = null;

		if (this._sipAudioMicCtx.state === 'suspended')
		{
			this._sipAudioMicCtx.resume();
		}
		this._SIPsocket = null;
		console.log('SIP calling Initialized');
		this.generateVideo();
	}

	async generateVideo()
	{

		this._meetingInfo = await this._roomClient.getMeetingInfo();

		const domain = import.meta.env.VITE_SIP_DOMAIN;

		this._callerURI = `sip:1089${this._meetingInfo?.meetingDetails?.uniqueMeetingID}@${domain}`;

		console.log('generateVideo', this._callerURI);

		// console.log('_callerURI', this._callerURI);

		const videoRef = document.createElement('video');

		this._selfVideo = videoRef;

		videoRef.autoplay = true;

		videoRef.loop = true;

		videoRef.src = '/sampleVideo.mp4';

		videoRef.addEventListener('canplay', async () =>
		{
			await videoRef.play().catch((err) =>
			{

				console.error('Error playing video:', err);
			});
			// await videoRef.play().catch((err) => {
			// 	console.error('Error playing video:', err)
			// });
		});

		videoRef.addEventListener('play', async () =>
		{

			console.log('in_play', videoRef);

			console.log('yyyyoooopppp_kkkk', videoRef.captureStream(0).getVideoTracks()[0]);

			// const videoStream = videoRef.captureStream(0);

			this._captureStream = videoRef.captureStream(0);

			this._customVideoTrack = videoRef.captureStream(0).getVideoTracks()[0];

			console.log('captureStream', this._captureStream);
			await this.generateAudio();
			// animationFrameId = requestAnimationFrame(drawVideoFrame);

		});

		console.log('videoRef', videoRef);

	}

	async generateAudio()
	{
		console.log('generateAudio');

		if (this._captureStream !== null)
		{

			if (this._registrationURI !== null)
			{

				const audioEl = document.createElement('audio');

				audioEl.src = '/sampleAudio.mp3';

				audioEl.autoplay = true;

				audioEl.loop = true;

				audioEl.addEventListener('play', async () =>
				{

					console.log('audioPlayingggggggggg', audioEl);

					const mediaStreamA = audioEl.captureStream();

					this._customAudioTrack = await audioEl.captureStream(0);

					const stream = new MediaStream([ mediaStreamA.getAudioTracks()[0] ]);

					if (this._audioContextRef.state === 'suspended')
					{
						console.log('suspended', this._audioContextRef);

						this._audioContextRef?.resume();
					}

					const audioConsumerStreamSource = this._audioContextRef?.createMediaStreamSource(
						stream
					);

					this._sampleAudioTrackId = mediaStreamA.getAudioTracks()[0].id;

					this._audioConsumersMap.set(mediaStreamA.getAudioTracks()[0].id, stream);

					audioConsumerStreamSource.connect(this._destinationRef);

					if (this._invitation === null)
					{

						this.sipjs();
					}

				});

				audioEl.addEventListener('canplay', async () =>
				{

					await audioEl.play().catch((err) => console.error('Error playing video:', err));
				});

				audioEl.crossOrigin = 'anonymous'; // Ensure cross-origin is set if needed

				console.log('mediaRecorder', this._destinationRef);

				// if (this._invitation === null)
				// {

				// 	this.sipjs();
				// }
			}

		}
	}

	close()
	{
		this._registrationURI = null;

		this._callerURI = null;

		this._roomClient = null;

		this._captureStream = null;

		this._selfVideo = null;

		this._sampleVideo = null;

		this._audioContextRef = null;
		this._destinationRef = null();
		this._gainNodeRef = null;

		this._audioConsumersMap = null;

		this._invitation = null;
	}

	async setupRemoteMedia(session)
	{

		session.sessionDescriptionHandler.peerConnection.getReceivers().forEach((async (receiver) =>
		{
			if (receiver.track && receiver.track.kind === 'audio')
			{
				console.log('receiver_callId', session.request.callId);
				console.log('Received audio track');
				console.log('Receiver Audio Track', receiver.track);

				// store.dispatch(roomActions.setSipAudioTracks({ track: receiver.track, callerId: session.request.callId }));

				if (this._roomClient._sipAudioMicCtx?.state === 'suspended')
				{
					console.log('this._sipAudioMicCtx', this._roomClient._sipAudioMicCtx);

					this._roomClient._sipAudioMicCtx.resume();
				}

				const str = new MediaStream();

				str.addTrack(receiver.track);

				this._roomClient._sipAudioStream = receiver.track;

				const producersStream = this._roomClient._sipAudioMicCtx.createMediaStreamSource(
					str
				);

				producersStream.connect(this._roomClient._sipDestination);

				// const audioEL = document.createElement('audio');

				// audioEL.srcObject = str;

				// audioEL.autoplay = true;

				// audioEL.muted = false;

				// this._roomClient.updateMic({ start: true });

				// audioEL.play();

				// audioEL.addEventListener('play', () => {
				// 	console.log('newAudiooooo');
				// })
			}
			else if (receiver.track && receiver.track.kind === 'video')
			{
				console.log('Receiver Video Track', receiver.track);

				this._roomClient._sipVideoStream = receiver.track;

				// this._roomClient.updateWebcam({ start: true });

				// store.dispatch(roomActions.setSipVideoTracks(receiver.track));

			}
		}));
		// console.log('Audio Elemnet', document.getElementById('audiodev'));

	}

	async makeACall()
	{

		const target = UserAgent.makeURI(`${this._callerURI}`);

		if (this._userAgent === undefined || this._userAgent === null)
		{
			return;
		}
		const inviter = new Inviter(this._userAgent, target);
		// REMOVED SESSIONDESCRIPTIONHANDLEROPTIONS ABOVE ^

		console.log('inviter', inviter, this._callerURI, target);

		this._invitation = inviter;

		inviter.stateChange.addListener((state) =>
		{
			// console.log('Session state changed to ', state);
			switch (state)
			{
				case SessionState.Initial:
					break;
				case SessionState.Establishing:
					break;
				case SessionState.Established:
					// if (this._roomClient._signalingSocket === null)
					// {
					// // console.log('_signalingSocket', this._signalingSocket);

					// 	this._roomClient.join({
					// 		roomId    : encodedRoomId,
					// 		joinVideo : true,
					// 		joinAudio : true
					// 	});
					// }
					this.setupRemoteMedia(inviter);
					console.log('encodedRoomId', inviter);
					break;
				case SessionState.Terminating:
				case SessionState.Terminated:
					this._called = false;
					this._roomClient.sendSipUserToLobby();
					// cleanUpMedia();
					console.log('Terminated');
					break;
				default:
					console.log('Unknown State');
			}
		});

		inviter.invite({
			sessionDescriptionHandlerOptions : {
				constraints : {
					audio : true,
					video : true
				},
				offerOptions : {
					iceRestart : true
				}
			}
		});

		const connectToServer = () =>
		{
			if (this._roomClient._signalingSocket === null)
			{
				const encodedRoomId = encodeURIComponent(decodeURIComponent(window.location.pathname.slice(1)));

				console.log('_signalingSocket', encodedRoomId);

				this._roomClient.join({
					roomId    : encodedRoomId,
					joinVideo : true,
					joinAudio : true
				});
			}
		};

		const pc = inviter.sessionDescriptionHandler.peerConnection;

		function monitorIceConnectionState(peerConnection)
		{
			console.log('Current ICE Connection State:', peerConnection.iceConnectionState);

			peerConnection.oniceconnectionstatechange = (event) =>
			{
				console.log('ICE Connection State Changed:', peerConnection.iceConnectionState);
				if (peerConnection.iceConnectionState === 'failed' || peerConnection.iceConnectionState === 'disconnected')
				{
					console.log('ICE connection failed.');
					inviter.bye().catch((error) =>
					{
						if (error)
						{
							inviter.cancel();
						}
					});
					window.location.reload();
				}
				else if (peerConnection.iceConnectionState === 'connected')
				{
					console.log('iceconnected');
					connectToServer();
				}
			};
		}

		monitorIceConnectionState(pc);

		console.log('peerConnection', pc);

		this._called = true;

		console.log('MakeACcallll');

		// inviter.invite();

		this._invitation.delegate = {
			onBye : (byeRequest) =>
			{

				console.log('user disconnecting........', byeRequest);
				// this._roomClient.sendSipUserToLobby();
			},
			onCancel : (onCancel) =>
			{
				console.log('user disconnecting........', onCancel);
			}
		};
	}

	async sipjs()
	{
		console.log('this_sipMediaStream', this._registrationURI);

		if (!this._registrationURI)
			return;
		this._SIPsocket = this._registrationURI.split('@')[1];

		this._registerID = this._registrationURI.split('@')[0].split(':')[1];

		let resgisterer;

		const callRemoteUser = async () =>
		{
			// Promise((resolve) => setTimeout(resolve, 2000));
			console.log('this._roomClient._delegateType', this._roomClient._delegateType);

			if (this._callerURI && !this._called)
			{
				console.log('callRemoteUser', this._callerURI);
				this.makeACall();
			}
		};

		const startUserAgent = async () =>
		{

			const myMediaStreamFactory = () =>
			{
				const _myStream = new MediaStream();

				console.log('mytrackkkk', this._destinationRef.stream.getAudioTracks()[0], this._customVideoTrack);

				_myStream.addTrack(this._destinationRef.stream.getAudioTracks()[0]);
				_myStream.addTrack(this._customVideoTrack);
				console.log('myMediaStreamFactory', this._customAudioTrack.getAudioTracks()[0], this._customVideoTrack);

				console.log('_myStream', _myStream);

				return Promise.resolve(_myStream);
			};
			const mySessionDescriptionHandlerFactory =
			// eslint-disable-next-line max-len
			Web.defaultSessionDescriptionHandlerFactory(myMediaStreamFactory);

			this._userAgent = new UserAgent({
				uri              : UserAgent.makeURI(`${this._registrationURI}`),
				transportOptions : {
					server : `wss://${this._SIPsocket}:7443`
				},
				authorizationUsername : this._registerID,
				authorizationPassword : 'thinkpad',
				displayName           : 'InMeet Participants',
				delegate              : {
					// onInvite,
					onNotify : async (notification) =>
					{
						console.log('Notification : ', notification);
						await startUserAgent();
					}
				},
				sessionDescriptionHandlerFactoryOptions : {
					peerConnectionConfiguration : {
						iceServers : [
							{ urls : 'stun:stun.instavc.com:19302'
							},
							{
								urls         : 'turn:coturn.instavc.com:443',
								'username'   : 'admin',
								'credential' : 'admin123'
							}
						]
					},
					peerConnectionOptions : {
						iceTransportPolicy : 'all'
						// iceCheckingTimeout : 1000
					}
				},
				sessionDescriptionHandlerFactory : mySessionDescriptionHandlerFactory
			});
			resgisterer = new Registerer(this._userAgent);
			// // Connect the user agent
			this._userAgent.start().then(() =>
			{
				resgisterer.register(
					{
						requestDelegate : {
							async onReject(response)
							{
								if (response.message.statusCode === 403 || response.message.statusCode !== 200)
								{
									this._userAgent = null;
									await startUserAgent();

								}
							},
							async onAccept(response)
							{
								try
								{
									if (response.message.statusCode === 200)
									{
										console.log('callinngggggg...', response);
										await callRemoteUser();
									}
								}
								catch (error)
								{
									console.error('Error handling successful registration:', error);
								}
							}
						}
					}
				);
			});
		};

		await startUserAgent();

	}

	acceptIncomingCall()
	{
		try
		{
			this._invitation.accept({});
		}
		catch (err)
		{
			console.log('acceptIncomingCall', err);
		}
	}

	rejectIncomingCall()
	{
		try
		{
			this._invitation.reject();

			window.location.reload();

		}
		catch (err)
		{
			console.log('rejectIncomingCall', err);

		}
	}

	rejectOngoingCall()
	{
		try
		{
			this._invitation.bye();

			// window.location.reload();

		}
		catch (err)
		{
			console.log('rejectOngoingCall', err);

		}
	}

	makeACallToSipUser(callerURI)
	{
		this._callerURI = callerURI;
		if (this._callerURI && !this._called)
		{
			this.makeACall();
		}
	}

	changeActiveSpeaker(activeSpeakerId)
	{

		if (activeSpeakerId !== null && activeSpeakerId !== this._roomClient._peerId)
		{

			const getPeerConsumers = makePeerConsumerSelector();

			const { webcamConsumer } = getPeerConsumers(store.getState(), activeSpeakerId);

			console.log('Peer_Active_Speaker', this._roomClient);

			if (webcamConsumer && this._selfVideo && this._invitation)
			{

				const pc = this._invitation.sessionDescriptionHandler.peerConnection;
				const videoToSend = webcamConsumer.track;
				const sender = pc.getSenders();

				console.log('peerConnection', sender);

				for (const i in sender)
				{
					if (sender[i].track.kind === 'video')
					{
						sender[i].replaceTrack(videoToSend);
					}
				}
			}
		}
	}

	replaceScreenConsumerTrack(peerId, sipModeratorId)
	{
		if (peerId)
		{
			const getPeerConsumers = makePeerConsumerSelector();

			const { screenConsumer } = getPeerConsumers(store.getState(), peerId);

			const pc = this._invitation.sessionDescriptionHandler.peerConnection;
			const videoToSend = screenConsumer.track;
			const sender = pc.getSenders();

			console.log('replaceScreenConsumerTrack', sipModeratorId);

			for (const i in sender)
			{
				if (sender[i].track.kind === 'video')
				{
					sender[i].replaceTrack(videoToSend);
				}
			}

			// Call the SIP conference action API in parallel
			if (screenConsumer && this._roomClient._roomTemplate?.meetingDetails?.uniqueMeetingID)
			{
				// Call the API in parallel without waiting for response
				this._roomClient.performSIPConferenceAction(sipModeratorId, 'start-screen-share').catch((error) =>
				{
					console.error('Error calling performSIPConferenceAction:', error);
				});
			}
		}
	}

	mergeActiveSpeakerAudio(consumers)
	{
		if (consumers)
		{
			console.log('consumers', consumers);

			const audioConsumers = Object.values(consumers).filter((p) => p.kind === 'audio');

			for (let i = 0; i < audioConsumers.length; i++)
			{
				if (!this._audioConsumersMap.has(audioConsumers[i].id))
				{
					if (this._audioContextRef.state === 'suspended')
					{
						console.log('suspended', this._audioContextRef);

						this._audioContextRef?.resume();
					}

					const stream = new MediaStream([ audioConsumers[i].track ]);

					const audioConsumerStreamSource = this._audioContextRef?.createMediaStreamSource(
						stream
					);

					audioConsumerStreamSource.connect(this._destinationRef);

					console.log('audioConsumerStreamSource', audioConsumerStreamSource);

					console.log('this._audioConsumersMap', this._destinationRef?.stream.getAudioTracks());

					// destinationRef?.current.stream.addTrack(audioConsumers[i].track);

					// sipStream.addTrack(audioConsumerStreamSource.mediaStream.getAudioTracks()[0]);

					this._audioConsumersMap.set(audioConsumers[i].id, audioConsumerStreamSource);
				}
			}

			for (const [ consumerId ] of this._audioConsumersMap.entries())
			{
				if (!audioConsumers.find((c) => consumerId === c.id))
				{
					// console.log('disconnect', audioContextRef?.current);

					// aCStreamSource.disconnect(this._gainNodeRef?.current);
					this._audioConsumersMap.delete(consumerId);
				}
			}
			if (this._sampleAudioTrackId && this._audioConsumersMap.has(this._sampleAudioTrackId))
			{

				const sampleStreamSource = this._audioConsumersMap[this._sampleAudioTrackId];

				console.log('sampleStreamSource', this._sampleAudioTrackId, sampleStreamSource);

				sampleStreamSource.disconnect(this._destinationRef);

				this._audioConsumersMap.delete(this._sampleAudioTrackId);

			}
		}
	}
}